import PagesTabs from "./tabs";
import { PRIVATE_CLOUD_CONSTANTS } from "@/components/header/header.constants";

const PrivateCloudTabs = () => {
  return <PagesTabs props={PRIVATE_CLOUD_CONSTANTS} />;
};

export default PrivateCloudTabs;
